// Kartenkacheln (CARTO). Zentrale Quelle für alle Karten der Anwendung.
//
// Der Key ist kein Secret: Vite setzt ihn zur Build-Zeit ein, danach ist er im
// ausgelieferten Bundle lesbar. Er identifiziert das Projekt gegenüber CARTO
// (Fair-Use-Kontingent) und darf deshalb nicht in fremde Projekte kopiert werden.
//
// Bewusst kein requireEnv(): Ein fehlender Key wirkt sich nur kosmetisch aus —
// CARTO liefert dann Kacheln mit "API KEY REQUIRED"-Wasserzeichen. Die Anwendung
// deswegen gar nicht erst starten zu lassen, wäre unverhältnismäßig. Unbemerkt
// bleibt es trotzdem nicht: Das Wasserzeichen steht quer über jeder Karte.
const TILE_STYLE_URL = 'https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

const cartoApiKey = import.meta.env.VITE_CARTO_API_KEY;

export const MAP_TILE_URL = cartoApiKey
  ? `${TILE_STYLE_URL}?key=${cartoApiKey}`
  : TILE_STYLE_URL;

export const MAP_TILE_MAX_ZOOM = 20;
